<template>
  <div>
    <div @click="dialogVisible = true">
      <slot></slot>
    </div>
    <el-dialog
      v-loading="loading"
      title="Добавить новый объект"
      :visible.sync="dialogVisible"
    >
      <el-form>
        <ImportObject/>
        <el-form-item label="Название объекта">
          <el-input v-model="form.name" placeholder/>
        </el-form-item>
        <el-form-item label="Код объекта">
          <el-input v-model="form.code"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Отменить</el-button>
      <el-button type="primary" @click="save">Добавить</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import ImportObject from "./ImportObject";

export default {
  name: 'AddObject',
  components: {ImportObject},
  props: ['parentId'],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {name: ''},
    };
  },

  methods: {
    fire() {
      if(this.$route.query.plan) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan)
      }

      if(this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    save() {
      let form = this.form;
      if (this.parentId) {
        form.parentId = this.parentId;
      }
      this.fire()
        .collection('objects')
        .add({
          ...form,
        }).then((add) => {
        this.$emit('update');
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Новый объект добавлен',
          type: 'success',
        });
        this.$emit('new-object', {
          id: add.id,
          parentId: this.parentId,
          ...this.form,
        });
        this.dialogVisible = false;
        this.form = {
          name: '',
        };
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboard/Objects/components/AddObject.vue